import React from 'react'
import DoctorSchedule from '../../components/DoctorSchedule/DoctorSchedule'

export default function DoctorSchedulePage() {
  
  return (
    <DoctorSchedule />
  )
}
